// extracted by mini-css-extract-plugin
export default {"table-grid":"site-error-log-table_table-grid__+pTFU"};